module.exports = __webpack_public_path__ + "img/addwise.ab29a57c.png";